import { IMAGES } from "../lib/site";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    n: "01",
    title: "Training & Development",
    desc: "Thoughtful, progressive training programs designed to build confidence and refine technique — from young prospects through to grand prix campaigners.",
    image: IMAGES.service_training,
    bullets: [
      "Full training board",
      "Young horse development",
      "Show preparation",
    ],
  },
  {
    n: "02",
    title: "Brokerage & Sales",
    desc: "Direct access to a curated pipeline of Czech Warmbloods, sourced from trusted European breeders and personally vetted before they ever step onto the trailer.",
    image: IMAGES.service_brokerage,
    bullets: [
      "Import & sourcing",
      "Pre-purchase support",
      "Match-making for buyer & rider",
    ],
  },
  {
    n: "03",
    title: "Show Coaching",
    desc: "Hands-on coaching at every level — building the horse-and-rider partnerships that win in the hunter, jumper, and equitation rings.",
    image: IMAGES.service_coaching,
    bullets: [
      "On-site & at-show coaching",
      "Equitation finals prep",
      "Hunter / jumper specific",
    ],
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#1A2B22] text-[#F9F9F6] py-24 md:py-32 px-6 md:px-12 lg:px-24 grain"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
        <Reveal className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#E0B894]">
            Our Practice
          </p>
        </Reveal>
        <Reveal delay={120} className="md:col-span-9">
          <h2
            data-testid="services-heading"
            className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]"
          >
            Three disciplines.
            <br />
            <em className="italic font-normal text-[#E0B894]">
              One uncompromising standard.
            </em>
          </h2>
        </Reveal>
      </div>

      <div className="space-y-20 md:space-y-28">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={i * 80}>
            <article
              data-testid={`service-item-${s.n}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center border-t border-[#F9F9F6]/15 pt-12 ${
                i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
              }`}
            >
              <div className="md:col-span-6">
                <div className="overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full aspect-[4/3] object-cover transition-transform duration-[1.6s] hover:scale-[1.04]"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="md:col-span-6">
                <div className="flex items-baseline gap-6">
                  <span className="font-display text-2xl text-[#E0B894]/70">
                    {s.n}
                  </span>
                  <h3 className="font-display text-3xl md:text-5xl tracking-tighter leading-none">
                    {s.title}
                  </h3>
                </div>
                <p className="mt-6 max-w-xl text-[#F9F9F6]/75 leading-relaxed">
                  {s.desc}
                </p>
                <ul className="mt-8 space-y-3">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-center gap-3 text-sm text-[#F9F9F6]/85"
                    >
                      <span className="w-6 h-px bg-[#E0B894]" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      {/* CTA strip */}
      <div className="mt-24 md:mt-32 border-t border-[#F9F9F6]/15 pt-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        <p className="font-display text-2xl md:text-3xl tracking-tighter max-w-xl">
          Looking for the right horse, or the right program?
        </p>
        <a
          href="#contact"
          data-testid="services-cta"
          className="inline-flex items-center gap-3 px-7 py-4 bg-[#F9F9F6] text-[#1A2B22] text-xs uppercase tracking-[0.24em] hover:bg-[#965C3B] hover:text-[#F9F9F6] transition-colors duration-300"
        >
          Schedule a Conversation
          <span aria-hidden>→</span>
        </a>
      </div>
    </section>
  );
};

export default Services;
